import { useMemo } from "react"

import { useStableSortedOrder } from "shared/lib/useStableSortedOrder"

import { TeamInvitationStatus } from "entities/team-invitations/types/TeamInvitationStatus"

import { ProjectTeamInvitationListProps } from "../ProjectTeamInvitationList"
import { ProjectTeamInvitationListViewModel } from "../ui/ProjectTeamInvitationListView"

export function useProjectTeamInvitationListViewModel({
  teamInvitations,
  ...rest
}: ProjectTeamInvitationListProps): ProjectTeamInvitationListViewModel {
  const sortedInvitations = useStableSortedOrder(
    { items: teamInvitations },
    { keepRemoved: true }
  )

  const pendingInvitationCount = useMemo(
    () =>
      sortedInvitations.filter(
        invitation => invitation.status === TeamInvitationStatus.PENDING
      ).length,
    [sortedInvitations]
  )

  return {
    ...rest,
    pendingInvitationCount,
    hasInvitations: sortedInvitations.length > 0,
    teamInvitations: sortedInvitations
  }
}
